module.exports = __webpack_public_path__ + "static/media/iar_vehicle_ems_selected.e12e10d9.svg";